export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '8px',
  borderRadius: '12px',
  border: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  backgroundColor: ({ palette }) => palette.background.default,
};

export const previewWrapperStyles = {
  position: 'relative',
  width: '100%',
  aspectRatio: '3 / 4',
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: ({ palette }) => palette.action.hover,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'text.secondary',
};

export const previewImageStyles = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

export const removeButtonStyles = {
  position: 'absolute',
  top: '4px',
  right: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  height: '28px',
  borderRadius: '999px',
  border: 'none',
  cursor: 'pointer',
  color: ({ palette }) => palette.common.white,
  backgroundColor: ({ palette }) => palette.action.active,
  WebkitTapHighlightColor: 'transparent',
};

export const retakeButtonStyles = {
  alignSelf: 'flex-start',
  textTransform: 'none',
};
